module.exports = __webpack_public_path__ + "img/settings-price.e5d089aa.svg";